/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateInstrumentSyncEntityRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CreateInstrumentSyncEntity.pb'
import {CreateInstrumentSyncEntityResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/CreateInstrumentSyncEntity.pb'


export const createInstrumentSyncEntity = (request: CreateInstrumentSyncEntityRequest, options?: CashRequestOptions) => post<CreateInstrumentSyncEntityRequest, CreateInstrumentSyncEntityResponse>("/2.0/cash/create-instrument-sync-entity", request, {...options, rejectOnError: true })